import PropTypes from 'prop-types';
import React, { useMemo, useEffect } from 'react';
import {
	Row,
	Col,
	Alert,
	Card,
	CardBody,
	Container,
	FormFeedback,
	Input,
	Label,
	Form,
	Spinner,
} from 'reactstrap';

//redux
import { useSelector, useDispatch } from 'react-redux';

import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import withRouter from '../../Components/Common/withRouter';

// Formik Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

// action
import { userResetPassword } from '../../slices/thunks';

import { createSelector } from 'reselect';
import AuthSlider from './authCarousel';
import { set } from 'lodash';
import {baseSettingsColor } from '../../slices/thunks';

const ResetPasswordPage = props => {
	document.title = 'Restablecer Contraseña';

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const [isResetting, setIsResetting] = React.useState(false);

	const selectorColor = createSelector(
				(state) => state.Settings,
				(data) => ({
					itemSettingsColor: data.itemSettingsColor,
				})
			);
	const { itemSettingsColor } = useSelector(selectorColor);
	useEffect(() => {
		dispatch(baseSettingsColor())
	}, []);

	const token = useMemo(() => params.get('reset_token'), [params]);

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			password: '',
			confirmPassword: '',
		},
		validationSchema: Yup.object({
			password: Yup.string()
				.min(6, 'La contraseña debe tener al menos 6 caracteres')
				.required('Por favor, ingrese su contraseña'),
			confirmPassword: Yup.string()
				.oneOf(
					[Yup.ref('password'), null],
					'Las contraseñas deben coincidir'
				)
				.required('Por favor, confirme su contraseña'),
		}),
		onSubmit: values => {
			setIsResetting(true);
			dispatch(
				userResetPassword({
					token,
					...values,
				})
			).finally(() => {
				setIsResetting(false);
				navigate('/');
			});
		},
	});

	const selectLayoutState = state => state.ForgetPassword;
	const selectLayoutProperties = createSelector(selectLayoutState, state => ({
		resetError: state.resetError,
		resetSuccessMsg: state.resetSuccessMsg,
	}));
	const { resetError, resetSuccessMsg } = useSelector(selectLayoutProperties);

	return (
		<React.Fragment>
			<div className='auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100'>
				<div className='bg-overlay'></div>
				<div className='auth-page-content overflow-hidden pt-lg-5'>
					<Container>
						<Row>
							<Col lg={12}>
								<Card className='overflow-hidden'>
									<Row className='g-0'>
										<AuthSlider />
										<Col lg={6}>
											<div className='p-lg-5 p-4'>
												<div className='text-center mt-2'>
													<h5 className='text-primary'>
														¿Has olvidado tu contraseña?
													</h5>
													<p className='text-muted'>
														Restablecer contraseña
													</p>

													<lord-icon
														src='https://cdn.lordicon.com/rhvddzym.json'
														trigger='loop'
														colors='primary:#0ab39c'
														className='avatar-xl'
														style={{
															width: '120px',
															height: '120px',
														}}
													></lord-icon>
												</div>

												<Alert
													className='border-0 alert-warning text-center mb-2 mx-2'
													role='alert'
												>
													Ingrese su nueva contraseña y confírmela
												</Alert>
												<div className='p-2'>
													{resetError ? (
														<Alert
															color='danger'
															style={{ marginTop: '13px' }}
														>
															{resetError}
														</Alert>
													) : null}
													{resetSuccessMsg ? (
														<Alert
															color='success'
															style={{ marginTop: '13px' }}
														>
															{resetSuccessMsg}
														</Alert>
													) : null}
													<Form
														onSubmit={e => {
															e.preventDefault();
															validation.handleSubmit();
															return false;
														}}
													>
														<div className='mb-4'>
															<Label className='form-label'>
																Contraseña
															</Label>
															<Input
																name='password'
																className='form-control'
																placeholder='Ingresa tu contraseña'
																type='password'
																onChange={
																	validation.handleChange
																}
																onBlur={validation.handleBlur}
																value={
																	validation.values.password ||
																	''
																}
																invalid={
																	validation.touched
																		.password &&
																	validation.errors.password
																		? true
																		: false
																}
															/>
															{validation.touched.password &&
															validation.errors.password ? (
																<FormFeedback type='invalid'>
																	<div>
																		{
																			validation.errors
																				.password
																		}
																	</div>
																</FormFeedback>
															) : null}
														</div>
														<div className='mb-4'>
															<Label className='form-label'>
																Confirmar Contraseña
															</Label>
															<Input
																name='confirmPassword'
																className='form-control'
																placeholder='Confirma tu contraseña'
																type='password'
																onChange={
																	validation.handleChange
																}
																onBlur={validation.handleBlur}
																value={
																	validation.values
																		.confirmPassword || ''
																}
																invalid={
																	validation.touched
																		.confirmPassword &&
																	validation.errors
																		.confirmPassword
																		? true
																		: false
																}
															/>
															{validation.touched
																.confirmPassword &&
															validation.errors
																.confirmPassword ? (
																<FormFeedback type='invalid'>
																	<div>
																		{
																			validation.errors
																				.confirmPassword
																		}
																	</div>
																</FormFeedback>
															) : null}
														</div>

														<div className='text-center mt-4'>
															<button
																type='submit'
																className='btn btn-label btn-primary w-50'
																style={{backgroundColor: itemSettingsColor?.primary_color, borderColor: itemSettingsColor?.primary_color}}
																disabled={
																	isResetting ||
																	!token ||
																	!validation.isValid
																}
															>
																{isResetting ? (
																	<i className='label-icon'>
																		<Spinner size='sm' />
																	</i>
																) : (
																	<i className='ri-lock-unlock-line label-icon'></i>
																)}{' '}
																Restablecer Contraseña
															</button>
														</div>
													</Form>
												</div>

												<div className='mt-4 text-center'>
													<p className='mb-0'>
														Espera, recuerdo mi contraseña{' '}
														<Link
															to='/login'
															className='fw-semibold text-primary text-decoration-underline'
														>
															{' '}
															Click{' '}
														</Link>{' '}
													</p>
												</div>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
				{/* <footer className='footer'>
					<Container>
						<Row>
							<Col lg={12}>
								<div className='text-center ff-bas fs-12 fw-medium text-uppercase text-muted'>
									<p className='mb-0'>
										&copy; {new Date().getFullYear()}
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</footer> */}
			</div>
		</React.Fragment>
	);
};

ResetPasswordPage.propTypes = {
	history: PropTypes.object,
};

export default withRouter(ResetPasswordPage);
